var React = require('react');

function ShadowXInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"filter":"url(#filter0_f)","key":0},React.createElement("ellipse",{"cx":"705.524","cy":"410","rx":"160","ry":"455.524","transform":"rotate(-90 705.524 410)","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("filter",{"id":"filter0_f","x":"0","y":"-3.05176e-05","width":"1411.05","height":"820","filterUnits":"userSpaceOnUse","colorInterpolationFilters":"sRGB"},[React.createElement("feFlood",{"floodOpacity":"0","result":"BackgroundImageFix","key":0}),React.createElement("feBlend",{"mode":"normal","in":"SourceGraphic","in2":"BackgroundImageFix","result":"shape","key":1}),React.createElement("feGaussianBlur",{"stdDeviation":"125","result":"effect1_foregroundBlur","key":2})]))]);
}

ShadowXInline.defaultProps = {"width":"1412","height":"820","viewBox":"0 0 1412 820","fill":"none"};

module.exports = ShadowXInline;

ShadowXInline.default = ShadowXInline;
